import { useEffect } from 'react'
import type { InfiniteData } from '@tanstack/react-query'
import {
  getFollowMeFeedPostsRemovedTopic,
  isFollowMeFeedPostRemovePayload,
  iotSubscribeTopics,
  iotUnsubscribeTopics,
} from '@core/State/PushData'
import { queryKeys } from '@core/Data/ReactQuery/constants'
import { queryClient } from '@core/Data/ReactQuery/queryClient'
import type { FollowMeSharedBet } from '@core/Areas/FollowMe/types'

export function useSharedBetsTopicSubscription() {
  useEffect(() => {
    const topic = getFollowMeFeedPostsRemovedTopic()

    const subscription = iotSubscribeTopics([topic]).subscribe(data => {
      if (!isFollowMeFeedPostRemovePayload(data.payload)) return
      const postId = Number(data.payload.postId)
      if (!postId) return

      queryClient.setQueriesData<InfiniteData<FollowMeSharedBet[]>>(
        { queryKey: queryKeys.followMeSharedBetsFeedBase() },
        currentCachedData => updateSharedBetStatus(postId)(currentCachedData)
      )
    })

    return () => {
      subscription.dispose()
      iotUnsubscribeTopics([topic])
    }
  }, [])
}

// =============
// Local Helpers
// =============

const updateSharedBetStatus =
  (ids: FollowMeSharedBet['postId'] | FollowMeSharedBet['postId'][]) =>
  (
    currentCachedData: InfiniteData<FollowMeSharedBet[]> | undefined
  ): InfiniteData<FollowMeSharedBet[]> | undefined => {
    if (!currentCachedData) return currentCachedData

    const postIdSet = new Set(Array.isArray(ids) ? ids : [ids])

    return {
      ...currentCachedData,
      pages: currentCachedData.pages.map(page =>
        page.map(bet =>
          postIdSet.has(Number(bet.postId))
            ? { ...bet, ticket: { ...bet.ticket, status: 'BettingClosed' } }
            : bet
        )
      ),
    }
  }
